import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'GoalCore',
  brandName: 'GoalCore',
  description: 'Sistema de agendamento para treinadores de futebol',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Treinador de futebol orientando equipa',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Sessão de treino de futebol',
  },
  testimonials: [
    {
      name: 'Mister Silva',
      role: 'Treinador de Futebol',
      text: 'O GoalCore revolucionou a forma como marco os treinos com os meus atletas. Tudo centralizado e fácil de gerir.',
      image: testimonial1,
    },
    {
      name: 'Tiago Nunes',
      role: 'Atleta',
      text: 'Finalmente uma forma simples de ver os horários dos treinos e confirmar a minha presença. Excelente!',
      image: testimonial2,
    },
    {
      name: 'Academia de Futebol',
      role: 'Direção',
      text: 'A gestão de horários dos vários escalões ficou muito mais eficiente. Recomendo a todos os clubes.',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'treinador',
    professionals: 'treinadores',
    business: 'clube',
    businesses: 'clubes',
    service: 'treino',
    services: 'treinos',
    client: 'atleta',
    clients: 'atletas',
    appointment: 'treino',
    appointments: 'treinos',
  },
  homepage: {
    hero: {
      badge: 'Futebol Profissional',
      title: 'Marque golos na gestão com GoalCore',
      description: 'Organize treinos, gerencie atletas e potencialize o desempenho da sua equipa.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Gestão de escalões', 'Controlo de presenças'],
    },
    statistics: [
      { value: '300+', label: 'Treinadores' },
      { value: '25k+', label: 'Treinos Agendados' },
      { value: '97%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Coordenação de Escalões',
        description: 'Gerir horários de diferentes faixas etárias e níveis sem conflitos é um desafio constante.',
        icon: 'Users',
        quote: {
          text: 'Com 5 escalões diferentes, o GoalCore salvou-me horas de planeamento semanal',
          author: 'Treinador António Costa',
          business: 'FC Esperança',
        },
      },
      {
        title: 'Controlo de Presenças',
        description: 'Saber quais atletas comparecem aos treinos é essencial para planeamento tático.',
        icon: 'CheckSquare',
        stats: [
          { label: 'Taxa de presença sem controlo:', value: '75%' },
          { label: 'Melhoria com sistema:', value: '92%' },
        ],
      },
      {
        title: 'Comunicação com Encarregados',
        description: 'Informar pais sobre horários, cancelamentos e eventos gera trabalho administrativo.',
        icon: 'MessageSquare',
        quote: {
          text: 'Os pais recebem todas as notificações automaticamente. Nunca mais tive reclamações',
          author: 'Mister João Santos',
          business: 'Academia Dragões',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'GoalCore: Tática digital vencedora',
      description: 'Plataforma especializada que compreende as necessidades únicas do futebol formativo e profissional.',
      features: [
        {
          title: 'Gestão Multi-Escalão',
          description: 'Organize treinos de diferentes faixas etárias sem conflitos de horários.',
        },
        {
          title: 'Registo de Presenças',
          description: 'Controle automático de comparências para otimizar planeamento.',
        },
        {
          title: 'Comunicação Automatizada',
          description: 'Notificações automáticas para atletas e encarregados de educação.',
        },
      ],
    },
    testimonials: {
      title: 'O que os treinadores dizem',
      description: 'Profissionais do futebol que escolheram GoalCore para otimizar seus treinos.',
    },
    finalCta: {
      title: 'Pronto para marcar o golo da eficiência?',
      description: 'Junte-se aos treinadores que já revolucionaram a gestão das suas equipas.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Contacte-nos',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de treinador',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
